/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RulesInputs */



/**
* | output |
* | --- |
* | "Rules" |
*
* @param {Nav_RulesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_rules = /** @type {((inputs?: Nav_RulesInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RulesInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Regeln")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("规则")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("規則")
	if (locale === "ko") return /** @type {LocalizedString} */ ("규칙")
	return /** @type {LocalizedString} */ ("Rules")
});